import { createAction } from '@reduxjs/toolkit';
import { IActivity } from '../../../../dto';
import { ACT_SET, MN_ACTIVITIES, TYPE_ELEMENT } from '../../../../common';

export const setActivity = createAction<IActivity>(
  `${MN_ACTIVITIES}/${TYPE_ELEMENT}/${ACT_SET}`,
);
